module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])]), _vm._v(" "), _c('p', {
    staticClass: "p9"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("His name was Karadur Atani. His brother called him Kaji; the officers of his household and garrison called him, to his face,"), _c('i', [_vm._v(" my lord")]), _vm._v(", and privately, among and to themselves, "), _c('i', [_vm._v("Dragon.")])])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("His home, Atani Castle, in Ippa, was known as Dragon Keep. The black-walled castle was ancient and solid, strong as the northern hills against which it had been raised. Unlike most of its neighbor castles, Dragon Keep had never been stormed or besieged or taken by an enemy.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("On a blue September morning, the man his soldiers named Dragon, accompanied by his best friend, his twin brother, and half the garrison, rode across the ridge of dry brown hillside below the Keep. He was hunting a wild boar. It had blundered out of the forest north of Chingura into a farmer’s cornfield, and, pursued by the enraged farmer and half a dozen of her neighbors, it had been brought inexpertly to bay at the river. Armed with rakes and hoes, the farmers had scored its sides, and taken its left eye. Pain-maddened, the boar had trampled one man, gored another, and charged north.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The twins rode side by side: Karadur on Smoke, his big black gelding, Tenjiro, to his right, on a bay mare. The brothers’ faces were alike, except that the bones in Karadur’s face showed harder and more prominent, and Tenjiro bore a clot of white scars along the line of his left cheek. Karadur Atani wore unadorned black, and his sun- gilt hair gleamed like thick silk rope in the sunlight. Tenjiro’s hands and clothing sparkled with jewels, and his hair was sleek as a greyhound’s coat. He was an elegant and graceful man: pretty, some called him, who looked no deeper than the surface. He had been absent from the Keep for nearly a year, and returned barely a month ago. He had been studying, he said, though he had refused to name his teacher, or even to say what the subject of his study had been.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Azil Aumson rode on Karadur’s left hand. He was a reserved, dark-haired man, slender, of no notable comeliness, except for the grace and sensitivity of his long, musician’s fingers, and the resonant beauty of his voice.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“The dogs have the scent,” said Tenjiro. “Do you want to follow further?” As he spoke, the clamor of the hounds and the sound of the pursuing horses grew close. The black boar burst up the hillside toward them. Murgain, the club-footed archery master, yelled orders, and the men divided, making a wide circle around the snorting, bleeding animal. Half the men dismounted, spears in their hands. The razor-sharp edges scattered rainbow light against the thick dry grass. The bowmen nocked the heavy steel-headed arrows to their bows. Winded and angry, the boar tossed its head at them, and turned in savage dancing rushes, trying to see them all with one good eye.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Tossing Smoke’s reins to his friend Azil Aumson, Karadur slid to the ground. The dragon-lord flexed his big fingers. The boar made a rush at the circle. The men shouted, waving their arms, and it retreated.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The dragon-lord glided into the circle. Recognizing an adversary, the boar snorted and pawed the ground like a bull.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“My lord?” said Murgain. He held out the heavy boar-spear.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Karadur waved it away. He strolled toward the enraged animal. Feigning a charge, it hooked its tusk toward his belly. He slipped easily away. The dogs, held fast, and furious about it, set up a frenzied barking.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Walking directly to the rank, sweating boar, the dragon- lord caught its tusk at the base with his left hand. Squealing in rage, it tried to swing its head. But Karadur Atani’s extraordinary strength held it motionless. He made a fist of his right hand, and brought it down like a hammer between the animal’s eyes.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The boar folded, and dropped. The soldiers shouted. Karadur caught the reins of his horse from Azil. Mounting, he wheeled his shaggy black horse, and rode on alone toward the castle.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The soldiers hung back, glancing at one another in unease. The dragon temper was famous throughout Ippa, and Karadur Atani had his share of it. Finally, talking softly, they moved in to disjoint and quarter the great beast. Tenjiro, holding his horse in place, was watching his brother ride along the edge of the hill.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Azil checked his own horse. Not looking at him, Tenjiro said, “Well, he"), _c('i', [_vm._v(" is")]), _vm._v(" in a temper.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Azil said diffidently, “He was—not happy last night He would not say what was disturbing him. I thought you and he might have had a disagreement.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“He has not told you? I thought he kept no secrets from you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The singer said quietly, “What is said between the two of you stays so, Tenjiro. It has always been so. You know that.” The dogs, released, charged uphill, splitting to either side of them in a brindled river. The horses danced a little.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“How diplomatic of him,” said the younger man. Then his ill-humor seemed to vanish. “Sorry. None of this is your fault. We did have a disagreement. He told me that he means to change. To take the form.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The singer said, “That I knew. He has been planning it all summer. He wanted only to wait until you came back, so that you could be here.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“So he told me, last night. I told him he should wait. He did not want to hear it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Azil’s face grew thoughtful. “Why did you tell him that?” he asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Tenjiro said, “I thought it would be obvious. He has no children.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I don’t understand.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Tenjiro frowned. “Azil, think! It is perilous to assume the dragon-nature. You know how our father died.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Azil had a child’s memory of Kojiro Atani: a huge man, bright as fire, before whom all other men seemed diminished. “Of course I know.” Everyone in the Atani domains knew how, four years after the birth of his twin sons, Kojiro the Black Dragon had flown ungoverned and enraptured over Ippa, burning forests and villages with his fiery breath, until, wild beyond recalling, he threatened the city of Mako, and the sorcerer Senmet crippled his great wings with a spell, and sent him tumbling to his death. “You think Karadur is in danger—of that?” The singer drew a long breath. “I do not believe it. Forgive me, Tenjiro, but your father, may his soul find peace, was—” He hesitated.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“A savage and undisciplined man,” said Tenjiro Atani. “But our father at least had a son. Kaji has no one.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“He has you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Tenjiro Atani smiled. There was no kindness in that smile, for the man with whom he spoke, nor for himself. “He has me. But I am not Dragon, my blood carries none of it. He needs children, to protect the transmission.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Whom would you have him marry?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Gods, I don’t care.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Azil said thoughtfully, “Reo Unamira offered Kaji his granddaughter last year.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Surprised, Tenjiro gave a shout of laughter. “Reo Unamira? I didn’t know the old pimp had a granddaughter. How old is the little sow—eight, ten?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Twelve, I believe. Her name’s Maia.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“What did Kaji say?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“He said he wasn’t ready to marry.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Well, of course. No, I would not have him wed that brigand’s spawn. Let him do as did our father: find some respectable family with empty coffers and an overabundance of girl-children. There must be a dozen of them between here and Nakase.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Azil said, “Truly he does not want to.” He colored. “Not for the reason you might think.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Oh, I know,” Tenjiro said. “He explained it last night, most emphatically. He does not want some innocent girl to suffer our mother’s fate.” Abruptly Tenjiro Urged his horse into motion. Azil followed him. They halted at the edge of the field. A gust of wind swept downhill at them, rustling the autumn grass. The banner over Dragon Keep snapped like a sail. It bore the Atani family sigil: the golden dragon, wings spread, on a white field.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Tenjiro said softly, “Imagine what it feels like, to be Dragon: to fly, to summon dragonfire, to be impervious to heat, cold, darkness...” A painful longing twisted his taut mouth, and roughened his usually self-possessed voice. The scars on his face darkened. For a moment he looked very like Karadur. “A power beyond price. But there is only one Dragon. It was not always so, the records say. But over the centuries our blood has grown thin.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Azil said, “But you do have power. You are wizard.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Tenjiro’s glance was sharp as a boar-spear. “Is that what common talk is saying?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The singer smiled. “It depends whom you talk to. Until you returned last month, half the domain believed that you and Kaji quarreled, and that you transformed yourself into a basilisk and flew into the mountains, or went looking for the treasure of Telmarniya in the center of the Crystal Lake. The other half believed you simply rode to Mako, and waited until his temper cooled before returning home.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“What do you believe?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Azil said simply, “I know you are not afraid of Kaji’s temper.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“You think I found the treasure of Telmarniya?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I think you found a teacher.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Now, why would you think that? I have no interest in the mumblings of some hedge-witch. And there are no wizards, no true wizards, in Ryoka. Not since the Mage Wars.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Azil said, “Senmet of Mako was a true wizard.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Yes. But she is dead. She was the last of them.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Then what are you? A warlock? A sorcerer?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Tenjiro moved his long fingers. Suddenly a cold mist seemed to rise from the ground, thickening and thickening until it seemed the two men stood isolated and imprisoned in a chill grey-white cloud. Azil’s horse whinnied in fright. The cloud swept castle, hillside, even his companion from his sight. “Tenjiro?” An ominous, wordless gabble filled his ears. “Tenjiro?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Slowly, grudgingly, the chill mist blew away. Tenjiro Atani’s eyes seemed darkened, and there was an expression in them that Azil had not seen before. “Sorcerer will do. You may call me that. Only say it softly.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“That was—unexpected,” Azil said. He was thankful for the steady sunlight bathing his shoulders. “I was right, then. You did find a teacher.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“You could say that. I went south, and east, through Nakase and Kameni, and finally to Nalantira Island, to the ruins of a castle where a great wizard once lived. It is said he was of dragon-kin. Later another wizard came to live there, and he must be buried in that place: no one lives there now, save goats and little monkeys, and madmen hunting for buried treasure. But the castle still exists. And inside the castle, hidden by magic spells, is the old wizard’s library, which holds all the books of magic that ever were in the world. It’s a big room, with shelves from floor to ceiling, holding books and scrolls and scraps of vellum and paper... It would take a lifetime to master them all. But I found what I needed.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Does Kaji know of this?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Tenjiro shrugged. “What is magic to Dragon?"), _c('i', [_vm._v(" He")]), _vm._v(" does not require it His attention is on his own desire; a desire whose fulfillment will change him utterly, in ways that you and I cannot even imagine. He is your friend, and you think:"), _c('i', [_vm._v(" I know him. He cannot change so much that I will not know him.")]), _vm._v(" But I tell you, Azil, he"), _c('i', [_vm._v(" can.")]), _vm._v(" The changeling-folk are different from the rest of us, and none more so than Dragon. Kojiro Atani and Erin diMako were good friends, close friends; but the Black Dragon burned the city of Mako to ash."), _c('i', [_vm._v(" That")]), _vm._v(" is the dragon-kind’s true nature. Karadur will change, and you will not know him, nor he you.” Tenjiro’s soft, elegant voice roughened. “We are a violent lineage, we Atani. You’re a singer: you know the stories.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Azil said evenly, “I know them.” He felt cold all over again, as if the magic mist wrapped him invisibly round. “You cannot keep him from his destiny, Tenjiro.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“That is not my wish. I want only to safeguard the line. Before he takes form, let Kaji do as did our father, and marry, and sire children. Then it will matter less when he sloughs his human nature, and vanishes into air, as did our grandmother, the Crimson Dragon, or flies into the sun.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("They were alone on the field below the castle. Azil’s brown horse, catching his rider’s disturbed mood, sidled and pulled against the reins. Stumbling a little over the words, the singer said, “I know that you and Kaji are not—not friends. It was always so. But you are all he has of family. If you think it dangerous for him to take the form, you must say so, and keep saying it until he hears you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Tenjiro snorted. “I tried; he will not listen. He’s stubborn as a Nakase ox. What else would you have me do?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I don’t know. Can your magic help?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Ah,” said Tenjiro. Something dark and smoky moved behind his pale blue eyes. He cocked his head. “Possibly.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("His voice caressed the word. “What do you know of changeling magic?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“I know what everyone knows,” Azil said. “Tukalina made changelings at the same time She made beasts and men.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Stories,” Tenjiro said disdainfully. “That is not what I meant.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“What do you mean?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“The power to change, like the gift of wizardry, cannot truly be taught. It is indwelling, in heart, bone, blood. Wizards use instruments to channel power. Language is an instrument, and even a village hedge-witch can scry in a mirror. Changelings direct power through a talisman. It is a device through which the changeling may concentrate his gift. Before he can assume the form, Karadur must make a talisman. He will need privacy, silence, a place where he can be alone, undisturbed, where no one, not even an animal, could blunder in to interrupt his work Where would he go?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“The tower,” Azil said. “The old signal tower. He had it rebuilt this summer. New floor, new roof, new chimney, new shutters. No one goes up there. He told Aum to tell the servants not to touch it, even to clean.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“And does he invite folk to visit it often?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“No. Never.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Have you been there?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Once.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Does he go there often?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Occasionally. Not often. He never stays long.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“The next time he goes to the tower, if you know, tell me. Especially if it is late at night.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("That evening, as was his custom three nights every week, Karadur ate in the guards’ hall. Those who had been on the previous morning’s hunt recounted it, with some embroidery, to those who had not. The boar’s head appeared, on a plate, with a cooked duck egg neatly substituting for the missing eye, and was admired, and eaten.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("After the meal, the tables were drawn back, and the young men challenged each other to wrestle. “Sing something,” Karadur suggested lazily to Azil. The two men sat side by side, shoulders brushing, near the fire. A decanter of red wine stood near them, with one cup. A rosewood harp lay propped against Azil’s knee.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Azil brought his harp onto his lap. “What would you hear?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Whatever you like.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Azil plucked the melody of ‘The Red Boar of Aidu.’"), _c('i', [_vm._v(" “The red boar came from the forest; the red boar came to the hills; his tusks were iron and his breath was fire and his bellow toppled the castle spire; O the red boar, the red boar of Aidu.” ")]), _vm._v("The firelight pulsed in time to his strokes. His low voice was clear and strong. The soldiers pounded on the tabletops, and sang the chorus.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Karadur did not sing, but when the song ended, he touched the musician’s shoulder a moment. “Sing another.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Sing ‘The Ballad of Ewain and Mariela,’ “ called someone.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The others groaned derisively. “Don’t listen to him, he’s lovesick,” yelled Devlin. “Give us ‘Dorian’s Ride!’ “")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Azil said, “I need to retune for that.” He bent over the pegs. A string snapped, lashing upward. “Damn. I’ll get another.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“No matter,” Karadur said. “Let it go.” His strong fingers caught the singer’s wrist. A torch flared as one of the doors opened.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Lorimir Ness, the garrison’s swordmaster and senior captain, stood framed momentarily in the doorway. Karadur beckoned to him. The captain crossed the hall to his side. “My lord.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“How serious were the injuries in Chingura today?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Nothing too bad, my lord. A shoulder gored, and a broken leg. Macallan rode to treat them.” Macallan was the Keep’s physician.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Good.” Karadur’s face grew thoughtful. “Lorimir, set a guard at the foot of the tower stairs tonight. Someone unimaginative.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Lennart,” Lorimir said. “He has no imagination whatsoever.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“No one comes to the tower chamber without my explicit permission.” Karadur glanced into the leaping shadows. “I don’t see my brother tonight. Is something wrong?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Not that I know of, my lord. Do you want me to send to find him?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“No, let it be,” Karadur said. With a slight bow, Lorimir left him. The young men, still eager and noisy, had begun to tease each other into an archery contest. He watched them for a while. Then: “Come,” he said abruptly to Azil.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Giving his harp into Ferlin’s care, Azil rose and followed his friend from the hall and across the courtyard. The sky beyond the castle walls was a deep dark blue. The autumn stars glittered in Karadur’s hair.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Later, well past midnight, the dragon-lord rose from the bed they shared. He dressed in the quiet darkness. As he turned toward the door, Azil lifted his head from the pillow. The room smelled faintly of applewood. Drowsily he said, “Kaji? Is all well?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“It is. Lie still.” The dragon-lord trailed warm fingers across the recumbent man’s chest. “I am going to the tower. Don’t follow me.” He closed the door behind him.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Azil rose on an elbow.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Ferlin the page curled on his pallet in the hall, snoring softly. Lennart, the guard at the foot of the tower stairs, bowed as Karadur passed. He climbed the narrow stairs to the octagonal chamber. Within, he stood a moment. The little room was dark, though moonlight through unshuttered windows touched the floor planks with silver. A lamp on a low table flared at his glance. Tapestries threaded with gold decorated the chamber walls. Wood for a fire lay neatly crossed in the hearth.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("A rectangular table in front of the unlit fire held three items: a lump of gold, a shallow bowl, and a knife. The dragon-lord crossed to the table. Lifting the knife, he tested its edge against his thumb. The blade was razor-sharp.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He set it down again. A shadow fell over the light. Dark wings emerged slowly out of polished stone. A dragon-shape arched against the ceiling beams. It was a presence he knew: he had seen it all his life, though as far as he knew, no one else had ever seen it, save Azil Aumson, and once or twice, Tenjiro. “Father?” he said softly.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("But the shadow, as always, did not respond. Drawing a long breath, Karadur looked at the hearth. Yellow flames burst along the edges of the wood.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("In the bedroom, Azil groped swiftly for his shoes. Then, with care not to disturb the sleeping page, he hurried along the corridor to another chamber. The door opened before his hand touched the wood, and Tenjiro slipped out to face him. Despite the lateness of the hour, he was fully dressed.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“He’s gone to the tower. He told me not to follow,” Azil said. “And he told Lorimir to set a guard on the tower stairs tonight. Someone unimaginative.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“He said that?” Tenjiro closed the door. “Good. Follow me.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Where are we going?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("But Tenjiro did not answer, only hastened along the corridor to the rear stairs.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("In the tower, the air was brilliant, bright and hot as the heart of a fire. Within it, as in the still center of a maelstrom, Karadur gripped the lump of gold. Fire ran along his big frame like water down a sluice. It poured in a controlled stream into his fingers. Slowly the lump took the shape of an armband fashioned like a dragon, fanged, bat-winged, jaws open, talons extended.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("In a small chamber in the deepest cellar of the castle, Tenjiro and Azil sat across from each other at a square table. A torch flared fitfully from a wall sconce, but despite the smoky heat it gave, the room was cold. Tenjiro leaned his head against the chair back. His long, ringed hands moved slowly, weaving a complex pattern into the smoky air.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“You will help me, Azil. I will make a little box, a little magic box. You are his friend, you love him. I need that love. Give me your love, your loyalty, your fidelity, so that I may feed it to the box, my little dark box...” The soft, light words, like an incantation, wound about Azil’s mind. He slumped boneless to the table. Cold spilled into the chamber. Merciless, it licked his bare skin, kissed his eyes, entered his lungs. Darkness closed about him like an imprisoning fist.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Karadur set the armband on the table. It pulsed with fire; beneath it, the thick oak began to char. Positioning his left arm over the bowl, Karadur took the knife and sliced his forearm. Blood dripped into the bowl. He scooped the band from the scarred table and dropped it into the bowl. The blood spat and frothed.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Churning, bubbling, the darkness flowed through Azil. As it left him, it took form, acquired edges, shape, weight. A small black box rested on the table in the cellar. Tenjiro’s hands stilled. Then, changing the pitch of his voice, he began to chant. A deep hum seemed to rise from the earth. It spiraled up the stairway to the courtyard, the kitchens, the stables. The dogs in their cages began to snore. Horses slept in the stable. Chickens slept in their pens. Sentries nodded at their posts. Lennart’s knees buckled; with a soft snore, he slid to his knees and then to his side.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("On the rampart overlooking the main gate, Lorimir nodded and woke and nodded again, until, infuriated by a weakness he could neither explain nor control, he set the point of his dagger against his rib, so that the flare of pain would wake him if he slept again.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The hum crept upstairs, to the tower chamber. The fire died. The alabaster lamp sputtered, went out. The sorcerous murmur intensified. It closed Karadur’s eyes and buckled his knees. He fell, boneless as the boar. His hand opened; the armband tumbled from his grip.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Tenjiro, rising, put a hand on Azil’s shoulder. “Azil. Get up.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Azil opened his eyes. His body ached as if he had been running, or fighting. Tenjiro bent over him. Tenjiro had done something ... some magic. A terrible lassitude held him immobile. “Up!” came a soft, irresistible command. He struggled to his feet.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Listen to me,” said that light, clear voice. “We will go to Karadur’s chamber now. We will take his talisman from him. You shall take it; I need every fiber of concentration to maintain the sleeping spell. If Kaji wakes before the talisman is in the box, he will burn the castle to ash around us. Once the talisman is in the box, you will go. The grooms are asleep; you’ll have no trouble getting horses. The binding spell will hold for an hour or two.” Tenjiro’s long hands moved irresistibly as he spoke. “It’s time. Bring the box.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Azil’s head was thick and muzzy, as if he had taken a dose of the sleeping potion Macallan kept to treat the sick or wounded. Obediently he lifted the black box.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“It’s cold,” he said, meaning the box. “Why is it so cold?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“It is made of void. It eats light.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The two men climbed the long stairs from cellar to kitchens to the upstairs chambers. Servants lay sleeping in hallways and chambers. The cook lay prone like a worshipper before his stockpot. One of the scullery boys snored at his feet. Old Lirith, chief of the castle women, a huge woman, massive and elegant, lay sprawled in utter indignity at the foot of the main stairs. Blood pooled in a pocket below her white hair.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Tenjiro halted. He reached a hand out. Then, drawing back, he moved past her. The somnolence that enveloped Dragon Keep from foundation to flagpole grew stronger as they moved. It lay heaviest at Karadur’s door. Tenjiro whispered a word.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The chamber door opened. They went in. Karadur lay motionless on the floor. Against the dark cloth of his shirt, a small golden circle flashed bright as a star.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Open the box,” Tenjiro whispered. Azil tipped up the lid of the black box. Inside was lightlessness, absence, a chill blackness that sucked light out of the air and devoured it. “There is the talisman. Take it,” Tenjiro said. “Put it in the box.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Azil walked to Karadur, and knelt. He lifted the shimmering band with both hands, wincing as he did so, put it in the box, and shut the lid. Karadur’s eyelids opened. With a harsh sound, he tried to sit upright. “Go!” Tenjiro said. Azil went out the door. Tenjiro said two words. Karadur tensed. A look of strain crossed his face.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Tenjiro said softly, “Farewell, dear brother. No, you cannot move, Kaji, so don’t trouble to resist. Or, no, go ahead, fight! Struggle with all your force. It will tire you out.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Tenjiro, what are you doing?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Leaving, dear brother. You cannot pretend to care. You think I don’t know how you hate me?” He touched the scar lines on his cheek. “In our mother’s womb you tried to destroy me even before our birth, just as you killed our mother. When you could not, you took what should have been mine.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Muscles stood out like ridges through Karadur’s shirt. “Tenjiro, you cannot believe that. A child in the womb makes no choices. I did not choose to be eldest. And by all the gods, I did not desire our mother’s death!”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“So you say,” said Tenjiro contemptuously. “I do not believe it. I have never believed it. I should have been the changeling child. I should have been eldest. I would have been dragon and wizard, both. Can you feel the chill, the weakness in your heart, Kaji? Do you like my little box? I made it especially for your little dragon. It will eat your little dragon, Kaji. It will eat your heart.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Tenjiro, don’t do this.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“It’s done. By darkness and by ice, I bind your power.” Below, in the Keep’s deserted courtyard, a horse whinnied. Karadur closed his eyes. His muscular body tightened with effort. The lamp began to glow. The wood in the hearth burst into flame. Tenjiro’s face whitened with surprise and sudden terror. He said a string of sibilant words, very fast. Karadur gasped, and slumped. The lamplight vanished; the fire hissed, and died as if doused in water. Tenjiro Atani laughed malignantly, and stretched his spine like an athlete too long confined. “Ah, I have you! Struggle as you will, Kaji. I learned my lessons well, this year.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("The door to the chamber opened. Azil stuck his head through. He said tonelessly, “Tenjiro, the horses are ready, we can leave.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Karadur lifted his head, “Azil?” He closed his eyes, then opened them again. “Azil, don’t go with him. I don’t know what he has told you, but whatever it is, it is not as you think.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("“Shut up, Kaji!” Tenjiro said. “I don’t want you to speak to him.” His supple hands wove swiftly. “There, now you can’t. Azil, wait for me in the courtyard.” Without looking at the man on the floor, Azil left the room. “It’s too late, Karadur. What, do you love him? He betrayed you. He is mine, now. Don’t worry; I will punish him for you. I will care for him with the exact tenderness that you have used toward me.” His face no longer resembled his brother’s. His eyes were wide and black. “Unfortunately, I suspect I cannot kill you, just as you could not butcher me in our mothers womb as you desired. But I can take everything you care for, and I will. Let us see who shall be Dragon! Fare ill, brother mine!”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Karadur Atani, trembling, strained to speak, to move. But his frozen muscles would not unlock. He lay paralyzed, while the tower room lightened with the dawn. At last, fire flared in the hearth. Grimacing with pain, Karadur pushed to his knees, to his feet, took an unsteady step, another. Tears, like droplets of blue flame, ran down his face.")])]), _vm._v(" "), _c('p', {
    staticClass: "p9"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-837710b4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Book1/OPS/section5.vue
// module id = 87
// module chunks = 0